
namespace GeniuzPOS.Purchase {
    import fld = PoPurOrderRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PoPurOrderGrid extends Serenity.EntityGrid<PoPurOrderRow, any> {
        protected getColumnsKey() { return PoPurOrderColumns.columnsKey; }
        protected getDialogType() { return PoPurOrderDialog; }
        protected getIdProperty() { return PoPurOrderRow.idProperty; }
        protected getInsertPermission() { return PoPurOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurOrderRow.localTextPrefix; }
        protected getService() { return PoPurOrderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        

        protected getButtons() {
            var buttons = super.getButtons();

         
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PoPurOrderService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            
            buttons.push({
                title: "Import From Excel",
                hint: "Import PR from Excel template",
                cssClass: "upload-pr-template-button",
                icon: "fa-cloud-upload-alt",
                separator: true,
                onClick: () => {
                    const dialog = new ImportPoDialog()
                    this.initDialog(dialog)
                    dialog.importState = () => {
                        Q.notifySuccess("Import from Excel successfully.")
                        this.refresh()
                    }
    
                    dialog.dialogOpen()
                }
            });

            buttons.push({
                title: "Download Template",
                hint: "Download Excel template for PR import",
                cssClass: "download-PR-template-button",
                icon: "fa-download",
                separator: true,
                onClick: () => {
                    window.location.href = Q.resolveUrl("~/Services/Csi/DownloadImportPRTemplate");
                }
            });

            return buttons
        }

        protected getColumns() {
            var columns = super.getColumns();
           
            // var item = this.itemAt(row);
            // if()
            
            columns.splice(5, 0, {
                id: 'Print CountApprove',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-countapprove" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };
            Q.first(filters, x => x.field == fld.CreateBy).init = w => {
                var userId = Authorization.userDefinition.Username;
                // console.log(Authorization.userDefinition.Username);
                // console.log(userId);
                (w as Serenity.LookupEditor).value = userId;
            };

            return filters;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-countapprove')) {
                    this.view.getRows()
                    const request = this.getView().params as PoPurOrderPrintData
                    request.SysDocNo = item.SysDocNo
                    request.Header = Q.tryFirst(PoPurOrderRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)

                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    if (fg != null) {
                        let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x=> x.ShopId == item.ShopId)
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }
                    request.Supdata = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x=> x.SupplId == item.SupplierId)
                    // request.Details = (PoPurInvoiceDtRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    // const getPO = Q.first(PoPurInvoiceRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo);
                    
                    let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                        let sss = p.ShopLogoOnFrontScreen
                        if(!Q.isEmptyOrNull(sss)){
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Purchase/PoPurOrder","")
                            request.URLpic = ap + "/upload/" +  p.ShopLogoOnFrontScreen
                        }else{
                            request.URLpic = "SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png
                        }

                        // item.PurOrderAmt = GeniuzPOS.Common.Helpers.Extensions.CsiNumberExtensions.ToThaiBahtText

                    console.log( window.location.host +'    ' +  window.location.href )
                    // request.URLpic = window.location.href + "/upload/info.jpg"
                        console.log( request.URLpic)
                    
                    let o = item.PayTermCode
                    if(!Q.isEmptyOrNull(o)){
                        request.Paydesc = Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == item.PayTermCode).PayTermDesc
                    }else {
                        request.Paydesc = ''
                    }
                    
                    console.log(request)

                    request.AppDate = "";
                    request.AppName = "";
                  
                    var fgApp = 0;
                    let appsign = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 79 && x.SysFg > 0)          
                    let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 32 && x.SysFg > 0)    
                    console.log(appsign)
                    console.log(lookupconsignfg)
                    let c = item.ApproveFg;
                    if (lookupconsignfg != null) {                         
                          if(c == 1){
                            fgApp = 0;
                          }else{
                            fgApp = 1;
                          }                       
                    } else {
                       
                        if(c == 1 && appsign != null){
                          fgApp = 3;
                            let namesign = Q.tryFirst(ListLastAppPurOrderRow.getLookup().items, x => x.SysDocNo == item.SysDocNo)         
                            console.log(namesign) 
                            if(namesign != null){
                               
                                request.AppDate = Q.formatDate(namesign.AppDate, "dd/MM/yyyy");
                                request.AppName = namesign.DisplayName;
                            }else{
                                fgApp = 0;
                            }
                        }else{
                          fgApp = 0;
                        }          
                    }

                    console.log( request.AppDate)
                    console.log( request.AppName)

                  

                    if(fgApp == 0){

                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                    }
                    if(fgApp == 3){

                    Q.postToService({ service: this.getService() + '/ExportAppSignPdf', request: request, target: '_blank' })
                    // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                    }else{
                        Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                    }
                    
                    ;
                }
                
            }
        }

        
    }
}